import React, { useEffect, useContext } from 'react';

import { Container, PageContainer } from '../styles';
import loadSindico from '../loadSindico';

import NovaSolicitacao from '../../../Components/Solicitacoes/NovaSolicitacao';

import NavbarSindico from '../NavbarSindico/index';

import { ContextSindico } from '../../../services/sindico';

export default function NovaSolicitacaoSindico() {
  const { tema, logoutSindico } = useContext(ContextSindico);

  useEffect(() => {
    if (!loadSindico()) {
      logoutSindico();
    }
  }, []);

  return (
    <PageContainer>
      <NavbarSindico />
      <Container>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div style={{ width: '100%' }}>
            <NovaSolicitacao isSindico tema={tema} />
          </div>
        </div>
      </Container>
    </PageContainer>
  );
}

// import React, { useEffect, useContext } from "react";

// import { Link } from "react-router-dom";
// import { Container } from "../../AnimationStyle";
// import loadSindico from "../loadSindico";

// import { useHistory } from "react-router-dom";
// // import AttachDocuments from "../../../Components/Solicitacoes/NovaSolicitacao/AttachDocuments";
// import NovaSolicitacao from "../../../Components/Solicitacoes/NovaSolicitacao";
// import NovaSolicitacaoLayout from "../../../Components/Solicitacoes/NovaSolicitacao/Layout";

// // import {imoveis, tiposSolicitacao, apontamentos} from "./mocks"

// import { ContextSindico } from "../../../services/sindico";

// export default function NovaSolicitacaoSindico() {

//   const history = useHistory();

//   useEffect(() => {
//     if (!loadSindico()) {
//       sessionStorage.removeItem("sindico");
//       history.push("/sindico");
//     }
//   }, [])

//   return (

//     <Container>
//       <h1>nova solicitacao sindico</h1>
//       <Link to="/sindico/solicitacoes-abertas">solicitacoes abertas</Link>
//       <div />
//       <Link to="/">Voltar para Home</Link>

//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center', alignItems: 'center',
//           width: '100%'
//         }}
//       >
//         <div style={{ width: 900 }}>
//           <NovaSolicitacaoLayout
//             getTipoSolicitacoes={getTipoSolicitacoes}
//             getVerificaAgendamento={getVerificaAgendamento}
//             getPeriodoAgente={getPeriodoAgente}
//             loadApontamentos={loadApontamentos}
//             getSolicitacoes={getSolicitacoes}
//             getSolicitacaoUnica={getSolicitacaoUnica}
//             loadingSolicitacaoSelecionada={loadingSolicitacaoSelecionada}
//             tema={() => { }}

//             loadImoveisDisponiveis={loadImoveisDisponiveis}
//             listaDeImoveis={listaDeImoveis}
//             setImovelSolicitacao={setImovelSolicitacao}
//             imovelSolicitacao={imovelSolicitacao}
//             loadingImoveis={loadingImoveis}
//           />
//         </div>
//       </div>
//     </Container>
//   )
// }
